export default "__VITE_ASSET__BTGh$EyV__"